import { render, staticRenderFns } from "./RequisitionInfo.vue?vue&type=template&id=3d3e5a54&scoped=true"
import script from "./RequisitionInfo.vue?vue&type=script&lang=js"
export * from "./RequisitionInfo.vue?vue&type=script&lang=js"
import style0 from "./RequisitionInfo.vue?vue&type=style&index=0&id=3d3e5a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e5a54",
  null
  
)

export default component.exports